import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AffiliateDashboardView from '../components/AffiliateDashboardView';
import affiliateApiClient, { getAffiliateSession, clearAffiliateSession } from '../lib/affiliateApiClient';

// The logged-in equivalent of AffiliatePortal.jsx's token link — same view,
// backed by a Bearer session instead of a bookmarked URL, and self-serve
// editable (payout details only; rate/status stay admin-only).
export default function AffiliateDashboard() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!getAffiliateSession()) {
      navigate('/affiliate/login');
      return;
    }
    setLoading(true);
    try {
      const res = await affiliateApiClient.get('/me');
      setData(res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/affiliate/login');
      }
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  const savePayout = async (payload) => {
    await affiliateApiClient.patch('/me', payload);
    await load();
  };

  const logout = () => {
    clearAffiliateSession();
    navigate('/affiliate/login');
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading your dashboard...</div>;
  if (!data) return null;

  return <AffiliateDashboardView data={data} editable onSavePayout={savePayout} onLogout={logout} />;
}
